var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { hearDigitsEventsConfig, log } from 'hx-analytics';
import { sendAnalyticsEvent } from './send-analytics-events.helper';
import { sendEventToHost } from './send-event-to-host.helper';
import { logError } from '../../logging/log-error.helper';
export function trackEvent(_a) {
    var baseEvent = _a.baseEvent, data = _a.data;
    var event = __assign(__assign({}, data), baseEvent);
    if (process.env['REACT_APP_NODE_ENV'] === 'development') {
        log('event:', baseEvent.type, event);
        return;
    }
    if (!hasEndpoint(event)) {
        logError({
            error: new Error('Missing or invalid analytics endpoint'),
            message: 'Analytics event missing required endpoint property',
            tag: {
                name: 'type-validation',
                value: 'missing-endpoint',
            },
            level: 'error',
            metadata: { event: event },
        });
        return;
    }
    var analytics = hearDigitsEventsConfig.analytics;
    if (!(analytics === null || analytics === void 0 ? void 0 : analytics.enabled))
        return;
    var isModeBoth = analytics.mode === 'both';
    if (isModeBoth || analytics.mode === 'internal')
        sendAnalyticsEvent(event);
    if (isModeBoth || analytics.mode === 'host')
        sendEventToHost({ eventType: 'analytics', event: event });
}
function hasEndpoint(eventData) {
    return typeof eventData.endpoint === 'string';
}
